import React from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import "./App.css";
import "./site.css";
import SiteHeader from "./components/SiteHeader";
import SiteFooter from "./components/SiteFooter";
import HomePage from "./pages/HomePage";
import AboutPage from "./pages/AboutPage";
import WalkPage from "./pages/WalkPage";
import ShopPage from "./pages/ShopPage";
import JournalPage from "./pages/JournalPage";
import ContactPage from "./pages/ContactPage";
import ImpressumPage from "./pages/ImpressumPage";
import BrandHub from "./BrandHub";

const ScrollToTop = () => {
  const loc = useLocation();
  React.useEffect(() => {
    if (!loc.hash) window.scrollTo(0, 0);
  }, [loc.pathname, loc.hash]);
  return null;
};

const PublicLayout = ({ children }) => (
  <div className="site" data-testid="site-shell">
    <SiteHeader />
    {children}
    <SiteFooter />
  </div>
);

function App() {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<PublicLayout><HomePage /></PublicLayout>} />
        <Route path="/about" element={<PublicLayout><AboutPage /></PublicLayout>} />
        <Route path="/walk" element={<PublicLayout><WalkPage /></PublicLayout>} />
        <Route path="/shop" element={<PublicLayout><ShopPage /></PublicLayout>} />
        <Route path="/journal" element={<PublicLayout><JournalPage /></PublicLayout>} />
        <Route path="/contact" element={<PublicLayout><ContactPage /></PublicLayout>} />
        <Route path="/impressum" element={<PublicLayout><ImpressumPage /></PublicLayout>} />
        <Route path="/brand" element={<BrandHub />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
